module.exports = __webpack_public_path__ + "static/img/RhebusTV_logo.59df436.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/RhebusTV_logo.jpg
// module id = 104
// module chunks = 0